/* HelloSpicy — scripts extraits de sections/hs-sticky-cta.liquid (audit A23 : sortis du HTML pour l'alléger et les mettre en cache). */
(function () {
      var bar = document.querySelector('[data-hs-sticky-cta]');
      if (!bar) return;

      var threshold = parseInt(bar.getAttribute('data-reveal-after'), 10) || 600;

      // Espace laisse entre le haut de la barre et le bas de la bulle de chat.
      var ECART_CHAT = 12;

      // Se place au-dessus de la tab bar mobile si elle est visible.
      // ⚠️ Pilote AUSSI --hs-sticky-safe : la safe area iOS ne doit être absorbée
      // que si la barre touche réellement le bas de l'écran. Les deux propriétés
      // vont ensemble.
      function positionAboveTabbar() {
        var tabbar = document.querySelector('.hs-tabbar');
        var offset = 0;
        if (tabbar && getComputedStyle(tabbar).display !== 'none') {
          offset = Math.round(tabbar.getBoundingClientRect().height) || 0;
        }
        bar.style.setProperty('--hs-sticky-offset', offset + 'px');
        bar.style.setProperty('--hs-sticky-safe', offset > 0 ? '0px' : 'env(safe-area-inset-bottom, 0px)');
      }

      // CORRECTIF DU 27/08/2026 — remonte la bulle Shopify Inbox juste au-dessus
      // de la barre. Voir la note detaillee en tete de fichier.
      // ⚠️ offsetHeight et NON getBoundingClientRect : l'animation d'entree
      // (translateY 100%) fausserait un rect pendant 0,22 s.
      // ⚠️ On additionne le `bottom` calcule : la barre peut deja etre remontee
      // au-dessus de la tab bar, et la bulle doit passer par-dessus les deux.
      function majDecalageChat() {
        var espace = 0;
        if (!bar.hidden && getComputedStyle(bar).display !== 'none') {
          var basBarre = parseFloat(getComputedStyle(bar).bottom) || 0;
          espace = bar.offsetHeight + basBarre + ECART_CHAT;
        }
        document.documentElement.style.setProperty('--hs-chat-offset', espace + 'px');
      }

      function onScroll() {
        var show = window.scrollY > threshold;
        if (show === !bar.hidden) return;
        bar.hidden = !show;
        if (show) positionAboveTabbar();
        // Appele a l'apparition ET a la disparition : la bulle doit redescendre
        // quand la barre s'en va.
        majDecalageChat();
      }

      function majTout() { positionAboveTabbar(); majDecalageChat(); }

      positionAboveTabbar();
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', majTout);
      // La bulle est injectee par l'app, souvent apres nous. Aucun risque de
      // course sur le CSS (il est declaratif), mais l'orientation et le
      // redimensionnement de la barre d'URL mobile changent la mesure.
      window.addEventListener('orientationchange', majTout);
    })();
